(() => {
  const states = new WeakMap();
  const selector = 'options-selection select[data-variant-option]';

  function context(target) {
    const form = target.closest('form[action*="/cart/add"]');
    const selection = form?.querySelector('variant-selection');
    if (!selection || Number(selection.dataset.variantCount) <= 250) return null;
    const selects = [...form.querySelectorAll(selector)];
    const input = form.querySelector('[name="id"]');
    if (!selects.length || !input) return null;
    return { form, selection, selects, input };
  }

  function queue(ctx) {
    const previous = states.get(ctx.form);
    if (previous) {
      clearTimeout(previous.timer);
      previous.controller.abort();
    }
    const state = { controller: new AbortController(), pending: true };
    states.set(ctx.form, state);
    ctx.form.setAttribute('aria-busy', 'true');
    state.timer = setTimeout(() => resolve(ctx, state), 150);
  }

  async function resolve(ctx, state) {
    const { form, selection, selects, input } = ctx;
    try {
      const ids = selects.map(select => select.selectedOptions[0]?.dataset.optionValueId);
      if (ids.some(id => !id)) throw new Error('Missing option value ID');
      const url = new URL(selection.getAttribute('product-url'), location.origin);
      url.pathname = url.pathname.replace(/\.js$/, '');
      url.search = new URLSearchParams({ section_id: 'variant-resolver', option_values: ids.join(',') });
      const response = await fetch(url, { signal: state.controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const payload = html.querySelector('[data-resolved-variant]');
      if (!payload) throw new Error('Variant response missing');
      const variant = JSON.parse(payload.textContent);
      const product = await selection.getProduct();
      if (states.get(form) !== state) return;
      if (!product) throw new Error('Product data missing');
      if (variant) {
        const index = product.variants.findIndex(item => String(item.id) === String(variant.id));
        if (index < 0) product.variants.push(variant);
        else product.variants[index] = variant;
        if (input instanceof HTMLSelectElement && ![...input.options].some(option => option.value === String(variant.id))) {
          input.add(new Option(variant.title, String(variant.id)));
        }
        input.value = String(variant.id);
        selection.variant = String(variant.id);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        input.value = '';
        selection.variant = 'unavailable';
      }
      state.pending = false;
      form.removeAttribute('aria-busy');
      console.log('[Variant fix] Resolved:', variant?.id ?? 'unavailable');
    } catch (error) {
      if (error.name === 'AbortError' || states.get(form) !== state) return;
      input.value = '';
      selection.variant = 'unavailable';
      form.removeAttribute('aria-busy');
      console.error('[Variant fix]', error);
    }
  }

  document.addEventListener('change', event => {
    if (!event.target.matches(selector)) return;
    const ctx = context(event.target);
    if (ctx) queue(ctx);
  }, true);

  document.addEventListener('submit', event => {
    if (!states.get(event.target)?.pending) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  customElements.whenDefined('variant-selection').then(() => {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const target = form.querySelector(selector);
      if (!target) return;
      const ctx = context(target);
      if (ctx) queue(ctx);
    });
  });
})();

